import React from 'react';
import PropTypes from 'prop-types';

import Placeholder from 'components/consumer/Placeholder';
import CtaButton from 'components/essentials/Cta/CtaButton';
import useZipCodeFromUser from 'global-state/zipCodeFromUser/useZipCodeFromUser';
import useIsZipCodeFromUserServiceable from 'global-state/isZipCodeFromUserServiceable/useIsZipCodeFromUserServiceable';

const PDPAddToBagButton = ({
  addingToCart = false,
  addToCartError = null,
  campaign,
  cartDisabled = false,
  isStickyButton = false,
  isCustomizeButton = false,
  loading = false,
  onClick,
  show = true,
}) => {
  const zipCodeFromUser = useZipCodeFromUser();
  const isZipCodeFromUserServiceable = useIsZipCodeFromUserServiceable();

  if (loading) {
    return <Placeholder type="rect" loading style={{ height: '44px' }} />;
  }

  return (
    <>
      <CtaButton
        disabled={
          (!!zipCodeFromUser && !isZipCodeFromUserServiceable) ||
          addingToCart ||
          cartDisabled
        }
        data-xc="add-cart-sticky-footer-button"
        onClick={event => onClick(event, isStickyButton)}
        styling="solid-button"
        color={campaign === 'barbie' ? 'hotpink' : 'black'}
        block
        tabIndex={!show ? '-1' : undefined}
        isLoading={addingToCart}
        className="min-w-[120px] px-4"
      >
        {isCustomizeButton ? 'Customize' : 'Add to Bag'}
      </CtaButton>
      {addToCartError && (
        <div className="text-sm font-bold text-red mt-4 text-center">
          {addToCartError}
        </div>
      )}
    </>
  );
};

PDPAddToBagButton.propTypes = {
  addingToCart: PropTypes.bool,
  addToCartError: PropTypes.string,
  campaign: PropTypes.string,
  cartDisabled: PropTypes.bool,
  isCustomizeButton: PropTypes.bool,
  isStickyButton: PropTypes.bool,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  show: PropTypes.bool,
};

export default PDPAddToBagButton;
